<!--
 * @FileDescription: 仓库管理（注释描述）
 * @Author: xy（作者）
 * @Date: 2020-07-07（时间）
 * @LastEditors: xy（最后更新人）
 * @LastEditTime: 2020-04-13（最后更新时间）
 -->
<template>
    <div class="page-container">
        <div class="page-container-height div-overflow">
            <div class="warehouse-title">全部仓库</div>
            <warehouseContent></warehouseContent>
        </div>
    </div>
</template>
<script>
    import {getPageAccount} from "@/utils/api";
    import {mixins} from "@/mixins/mixins";
    import warehouseContent from './warehouseContent'
    export default {
        mixins:[mixins],
        data(){
            return{

            }
        },
        watch: {

        },
        mounted () {

        },
        created () {

        },
        components: {
            warehouseContent

        },
        methods: {
            /**
             * @description: 此为方法注释（方法描述）
             * @param {参数类型} 参数名称
             * @return void
             */


        },

    }
</script>
<style scoped lang="scss">
.page-container-height{
    background-color: #fff;
    padding: 20px 70px 40px;
    .warehouse-title{
        color: #333333;
        font-size: 22px;
        font-weight: 700;
    }

}
</style>

